import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  AccordionControlBaseWrapper
} from './styled'

export class AccordionControlBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      dropdown,
      onClick
    } = this.props

    return (
      <AccordionControlBaseWrapper
        className={ClassNames(
          'accordion-control-base',
          { 'is-dropdown': dropdown },
          // Option
          className
        )}
        theme={{
          // Default
        }}
        onClick={onClick}
      >
        {children}
      </AccordionControlBaseWrapper>
    )
  }

  static defaultProps = {
    onClick: () => { }
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    dropdown: PropTypes.bool,
    onClick: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.func
    ]),

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
